import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

const notFoundPage = () => {
  return (
    <>
      <Row className='mb-3'>
        <Col xs={12}>
          <div className='p-3 p-md-4 p-lg-5 text-muted bg-light br-3'>
            <div className='px-0 px-sm-3 py-5 p-lg-5'>
              <h1 className="fw-semibold">
                404
              </h1>
              <h3>Page not found</h3>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default notFoundPage